import React from "react";
import {
  AnalyticsSection,
  StatCard,
  AreaChart,
  PieChart,
  BarChart,
} from "./ChartComponents";
import {
  months,
  revenueData,
  memberData,
  eventData,
  emailData,
  invoicingData,
  websiteData,
} from "./analyticsData";

const ChamberSummary = () => {
  return (
    <div className="space-y-8">
      {/* Revenue Overview */}
      <AnalyticsSection title="Total revenue from memberships and events">
        <div className="mb-4">
          <h3 className="text-4xl font-bold text-gray-900 mb-6">
            {revenueData.total}
          </h3>

          <div className="mt-8 w-full" style={{ height: "350px" }}>
            <AreaChart
              series={[revenueData.membershipSeries, revenueData.eventsSeries]}
              labels={months}
              height={300}
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
          <StatCard
            title="Total membership revenue"
            value={revenueData.membership}
          />
          <StatCard
            title="Total events revenue (event sponsorship & ticket sales)"
            value={revenueData.events}
          />
        </div>
      </AnalyticsSection>

      {/* Member Status Cards */}
      <AnalyticsSection title="Membership Status">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
          <StatCard
            title="Active Members"
            value={memberData.activeMembers.toString()}
            backgroundColor="bg-green-50"
            textColor="text-green-700"
            borderColor="border-green-200"
          />
          <StatCard
            title="Suspended Members"
            value={memberData.suspendedMembers.toString()}
            backgroundColor="bg-yellow-50"
            textColor="text-yellow-700"
            borderColor="border-yellow-200"
          />
          <StatCard
            title="Cancelled Members"
            value={memberData.cancelledMembers.toString()}
            backgroundColor="bg-red-50"
            textColor="text-red-700"
            borderColor="border-red-200"
          />
        </div>
      </AnalyticsSection>

      {/* Key Metrics Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
        {/* Member Stats */}
        <StatCard title="Total Members" value={memberData.totalMembers} />

        {/* Event Stats */}
        <StatCard title="Upcoming Events" value={eventData.upcomingEvents} />

        {/* Email Stats */}
        <StatCard title="Average Email Open Rate" value={emailData.openRate} />

        {/* Invoicing Stats */}
        <StatCard
          title="Receivable Invoices"
          value={invoicingData.outstanding}
        />

        {/* Website Stats */}
        <StatCard
          title="Monthly Website Visits"
          value={websiteData.totalVisits.toLocaleString()}
        />

        {/* Retention Rate */}
        <StatCard
          title="Member Retention Rate"
          value={memberData.memberRetentionRate}
        />
      </div>

      {/* Charts Overview */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* Member Breakdown */}
        <AnalyticsSection title="Member breakdown by size">
          <PieChart
            segments={memberData.memberBreakdown}
            height={250}
            segmentValueLabel="members"
          />
        </AnalyticsSection>

        {/* Member Status Breakdown */}
        <AnalyticsSection title="Member status breakdown">
          <PieChart
            segments={memberData.memberStatusBreakdown}
            height={250}
            segmentValueLabel="members"
          />
        </AnalyticsSection>

        {/* New Members */}
        <AnalyticsSection title="New members">
          <div className="h-80">
            <BarChart
              data={memberData.newMembersMonthly}
              categories={months}
              height={280}
            />
          </div>
        </AnalyticsSection>

        {/* Payment Status */}
        <AnalyticsSection title="Invoice payment status">
          <PieChart
            segments={invoicingData.paymentStatus}
            height={250}
            segmentValueLabel="dollars"
          />
        </AnalyticsSection>
      </div>
    </div>
  );
};

export default ChamberSummary;
